import { isDefinitiveSupabaseAuthFailure } from "@/lib/supabaseAuthFailure";

export type SessionProbeResult = {
  data?: { user: unknown } | null;
  error: { status?: number } | null;
};

/** Asks Supabase whether the browser's current session is still valid. */
export type SessionProbe = () => Promise<SessionProbeResult>;

/**
 * True only when Supabase itself says the browser's session is gone. A probe
 * that times out, throws or hits a Supabase outage keeps the session: an
 * operator is never signed out because the confirmation could not be made.
 */
export async function confirmSessionEnded(
  probeSession: SessionProbe,
): Promise<boolean> {
  try {
    const { data, error } = await probeSession();
    if (error) return isDefinitiveSupabaseAuthFailure(error.status);
    return !data?.user;
  } catch {
    return false;
  }
}
